var dataModel = {
  '1': {
    'apiEndpoint': 'https://api.channelsight.com/api/1.44/feed?key=b0d332b1-2100-40ad-89e1-c696c042a3c4&assetId=2282',
    'prodName': 'Gordon’s Tropical Passionfruit Gin 70cl',
    'prodImg': './widget/product--1.png',
    'navBgColor': '#912b88',
    'navLogoSrc': './navbar/logo--white.svg',
    'retailers': {},
    'carousel': true,
    'carouselFull': true,
    'carouselData': {
      1: {
        2: {
          'title': "Gordon’s Special Dry London Gin 70cl, 37.5%&nbsp;ABV",
          'img': "./products/prod--2.png",
          'url': "",
          'dataAssetId': "2236"
        },
        3: {
          'title': "Gordon’s Sicilian Lemon Gin 70cl, 37.5%&nbsp;ABV",
          'img': "./products/prod--3.png",
          'url': "",
          'dataAssetId': "2236"
        },
        4: {
          'title': "Gordon's Premium Pink Distilled Gin 70cl, 37.5%&nbsp;ABV",
          'img': "./products/prod--4.png",
          'url': "",
          'dataAssetId': "2236"
        },
        /*5: {
          title: "Gordon's MORELLO cherry Gin 70cl, 26%&nbsp;ABV",
          img: "./products/prod--5.png",
          url: "",
          dataAssetId: "2236"
        },*/
        6: {
          'title': "Gordon’s White Peach Distilled Gin 70cl, 37.5%&nbsp;ABV",
          'img': "./products/prod--6.png",
          'url': "",
          'dataAssetId': "2236"
        },
        7: {
          'title': "Gordon’s Mediterranean Orange Distilled Gin 70cl, 37.5%&nbsp;ABV",
          'img': "./products/prod--7.png",
          'url': "",
          'dataAssetId': "2236"
        },
        8: {
          'title': "Gordon’s Sloe Gin 70cl, 26%&nbsp;ABV",
          'img': "./products/prod--8.png",
          'url': "",
          'dataAssetId': "2236"
        },
        9: {
          'title': "Gordon’s Premium Pink 0.0% Alcohol Free Spirit&nbsp;70cl",
          'img': "./products/prod--9.png",
          'url': "",
          'dataAssetId': "2236"
        },
        10: {
          'title': "Gordon’s 0.0% Alcohol Free Spirit&nbsp;70cl",
          'img': "./products/prod--10.png",
          'url': "",
          'dataAssetId': "2236"
        }
      }
    },
    'ui': {
      'primaryColor': '#912b88'
    },
    'hero': {
      'video': {
        'active': false,
        'bgColor': '#58bbd0',
        'gradLeft': 'linear-gradient(90deg, rgba(88,107,208,1) 0%, rgba(88,107,208,0) 100%)',
        'gradRight': 'linear-gradient(-90deg, rgba(88,107,208,1) 0%, rga(88,107,208,0) 100%)'
      },
      'bgImg': {
        'bgColor': '#439aaf',
        'gradLeft': 'linear-gradient(90deg, rgba(67,154,175,1) 0%, rgba(67,154,175,0) 100%)',
        'gradRight': 'linear-gradient(-90deg, rgba(67,154,175,1) 0%, rgba(67,154,175,0) 100%)',
        'maxWidth': '1400px'
      },
      'serve_1': true,
      'serve_2': true
    },
    'recipes': {
      1: {
        'title': 'HOW TO MAKE A GORDON’S PASSIONFRUIT GIN & TONIC',
        'image': "./serves/carouselFull__serve--2.png",
        'units': "1.9 UK Units",
        'copy': {
          'ingredients': {
            1: {
              'measure': "50ML",
              'ingredient': "GORDON's PASSIONFRUIT",
            },
            2: {
              'measure': "150-200ml",
              'ingredient': "TONIC",
            }
          },
          'garnish': {
            1: "WEDGE OF PASSION FRUIT",
          },
          'method': [
            "ADD ALL THE INGREDIENTS TO A COPA&nbsp;GLASS",
            "FILL WITH ICE"
          ],
        }
      },
      2: {
        'title': 'HOW TO MAKE A GORDON’S PASSIONFRUIT & PINEAPPLE MARTINI',
        'image': './serves/carouselFull__serve--1.png',
        'units': '1.875 UK Units',
        'copy': {
          'ingredients': {
            1: {
              'measure': '50ML',
              'ingredient': 'GORDON\'s PASSIONFRUIT'
            },
            2: {
              'measure': '100ML',
              'ingredient': 'PINEAPPLE JUICE'
            },
            3: {
              'measure': '12.5ML',
              'ingredient': 'LIME JUICE'
            },
            4: {
              'measure': '12.5ML',
              'ingredient': 'VANILLA SYRUP'
            }
          },
          'garnish': {
            1: "WEDGE OF PASSION FRUIT"
          },
          'method': [
            'ADD ALL THE INGREDIENTS TO A COCKTAIL SHAKER',
            'FILL WITH ICE',
            'SHAKE TO MIX ',
            'FINE-STRAIN INTO A CHILLED',
            'MARTINI GLASS OR COUPE'
          ]
        }
      },


    }

  },
  '2': {
    'apiEndpoint': 'https://api.channelsight.com/api/1.44/feed?key=b0d332b1-2100-40ad-89e1-c696c042a3c4&assetId=2238',
    'prodName': 'Gordon’s Special Dry London Gin 70cl',
    'prodImg': './widget/product--2.png',
    'navBgColor': '#912b88',
    'navLogoSrc': './navbar/logo--white.svg',
    'retailers': {

    },
    'carousel': true,
    'carouselFull': true,
    'ui': {
      'primaryColor': '#00933b'
    },
    'hero': {
      'video': {
        'active': false,
        'bgColor': '#29d9e9',
        'gradLeft': 'linear-gradient(90deg, rgba(41,217,233,1) 0%, rgba(41,217,233,0) 100%)',
        'gradRight': 'linear-gradient(-90deg, rgba(41,217,233,1) 0%, rgba(41,217,233,0) 100%)'
      },
      'bgImg': {
        'bgColor': '#439aaf',
        'gradLeft': '',
        'gradRight': '',
        'maxWidth': 'none'
      },
      'product': '',
      'serve_1': true,
      'serve_2': false
    },
    'recipes': {
      1: {
        'image': "./serves/carouselFull__serve--1.png",
        'units': "1.9 UK Units",
        'copy': {
          'ingredients': {
            1: {
              'measure': "WRONG",
              'ingredient': "WRONG",
            },
            2: {
              'measure': "150-200ml",
              'ingredient': "TONIC",
            }
          },
          'garnish': {
            1: "WEDGE OF PASSION FRUIT",
          },
          'method': [
            "ADD ALL THE INGREDIENTS TO A COPA GLASS",
            "FILL WITH ICE"
          ],
        }
      },
      2: {
        'image': './serves/carouselFull__serve--1.png',
        'units': '1.875 UK Units',
        'copy': {
          'ingredients': {
            1: {
              'measure': '50ML',
              'ingredient': 'GORDON\'s PASSIONFRUIT'
            },
            2: {
              'measure': '100ML',
              'ingredient': 'PINEAPPLE JUICE'
            },
            3: {
              'measure': '12.5ML',
              'ingredient': 'LIME JUICE'
            },
            4: {
              'measure': '12.5ML',
              'ingredient': 'VANILLA SYRUP'
            }
          },
          'garnish': {
            1: "WEDGE OF PASSION FRUIT"
          },
          'method': [
            'ADD ALL THE INGREDIENTS TO A COCKTAIL SHAKER',
            'FILL WITH ICE',
            'SHAKE TO MIX ',
            'FINE-STRAIN INTO A CHILLED',
            'MARTINI GLASS OR COUPE'
          ]
        }
      }

    }
  },
  '3': {
    'apiEndpoint': 'https://api.channelsight.com/api/1.44/feed?key=b0d332b1-2100-40ad-89e1-c696c042a3c4&assetId=2276',
    'prodName': 'Gordon’s Sicilian Lemon Gin 70cl',
    'prodImg': './widget/product--3.png',
    'navBgColor': '#912b88',
    'navLogoSrc': './navbar/logo--white.svg',
    'retailers': {

    },
    'ui': {
      'primaryColor': '#000000'
    },
    'hero': {
      'video': {
        'active': false,
        'bgColor': '#000000',
        'gradLeft': 'linear-gradient(90deg, rgba(41,217,233,1) 0%, rgba(41,217,233,0) 100%)',
        'gradRight': 'linear-gradient(-90deg, rgba(41,217,233,1) 0%, rgba(41,217,233,0) 100%)'
      },
      'bgImg': {
        'bgColor': '#000000',
        'gradLeft': '',
        'gradRight': '',
        'maxWidth': 'none'
      },
      'product': '',
      'serve_1': true,
      'serve_2': false
    },
    'recipes': {
      1: {
        'image': "./serves/carouselFull__serve--1.png",
        'units': "PLACEHOLDER",
        'copy': {
          'ingredients': {
            1: {
              'measure': "PLACEHOLDER",
              'ingredient': "PLACEHOLDER",
            },
            2: {
              'measure': "PLACEHOLDER",
              'ingredient': "PLACEHOLDER",
            }
          },
          'garnish': {
            1: "PLACEHOLDER",
          },
          'method': [
            "PLACEHOLDER",
            "PLACEHOLDER"
          ],
        }
      },
      2: {
        'image': './serves/carouselFull__serve--1.png',
        'units': 'PLACEHOLDER',
        'copy': {
          'ingredients': {
            1: {
              'measure': 'PLACEHOLDER',
              'ingredient': 'PLACEHOLDER'
            },
            2: {
              'measure': 'PLACEHOLDER',
              'ingredient': 'PLACEHOLDER'
            },
            3: {
              'measure': 'PLACEHOLDER',
              'ingredient': 'PLACEHOLDER'
            },
            4: {
              'measure': 'PLACEHOLDER',
              'ingredient': 'PLACEHOLDER'
            }
          },
          'garnish': {
            1: "PLACEHOLDER"
          },
          'method': [
            'PLACEHOLDER'
          ]
        }
      }

    }
  },
  '4': {
    'apiEndpoint': 'https://api.channelsight.com/api/1.44/feed?key=b0d332b1-2100-40ad-89e1-c696c042a3c4&assetId=2277',
    'prodName': 'Gordon’s Premium Pink Gin 70cl',
    'prodImg': './widget/product--4.png',
    'navBgColor': '#912b88',
    'navLogoSrc': './navbar/logo--white.svg',
    'retailers': {

    },
    'ui': {
      'primaryColor': '#000000'
    },
    'hero': {
      'video': {
        'active': false,
        'bgColor': '#000000',
        'gradLeft': 'linear-gradient(90deg, rgba(41,217,233,1) 0%, rgba(41,217,233,0) 100%)',
        'gradRight': 'linear-gradient(-90deg, rgba(41,217,233,1) 0%, rgba(41,217,233,0) 100%)'
      },
      'bgImg': {
        'bgColor': '#000000',
        'gradLeft': '',
        'gradRight': '',
        'maxWidth': 'none'
      },
      'product': '',
      'serve_1': true,
      'serve_2': false
    },
    'recipes': {
      1: {
        'image': "./serves/carouselFull__serve--1.png",
        'units': "PLACEHOLDER",
        'copy': {
          'ingredients': {
            1: {
              'measure': "PLACEHOLDER",
              'ingredient': "PLACEHOLDER",
            },
            2: {
              'measure': "PLACEHOLDER",
              'ingredient': "PLACEHOLDER",
            }
          },
          'garnish': {
            1: "PLACEHOLDER",
          },
          'method': [
            "PLACEHOLDER",
            "PLACEHOLDER"
          ],
        }
      },
      2: {
        'image': './serves/carouselFull__serve--1.png',
        'units': 'PLACEHOLDER',
        'copy': {
          'ingredients': {
            1: {
              'measure': 'PLACEHOLDER',
              'ingredient': 'PLACEHOLDER'
            },
            2: {
              'measure': 'PLACEHOLDER',
              'ingredient': 'PLACEHOLDER'
            },
            3: {
              'measure': 'PLACEHOLDER',
              'ingredient': 'PLACEHOLDER'
            },
            4: {
              'measure': 'PLACEHOLDER',
              'ingredient': 'PLACEHOLDER'
            }
          },
          'garnish': {
            1: "PLACEHOLDER"
          },
          'method': [
            'PLACEHOLDER'
          ]
        }
      }

    }
  },
  '5': {
    'apiEndpoint': 'https://api.channelsight.com/api/1.44/feed?key=b0d332b1-2100-40ad-89e1-c696c042a3c4&assetId=2278',
    'prodName': 'Gordon’s Morello Cherry Gin 70cl',
    'prodImg': './widget/product--5.png',
    'navBgColor': '#912b88',
    'navLogoSrc': './navbar/logo--white.svg',
    'retailers': {

    },
    'ui': {
      'primaryColor': '#000000'
    },
    'hero': {
      'video': {
        'active': false,
        'bgColor': '#000000',
        'gradLeft': 'linear-gradient(90deg, rgba(41,217,233,1) 0%, rgba(41,217,233,0) 100%)',
        'gradRight': 'linear-gradient(-90deg, rgba(41,217,233,1) 0%, rgba(41,217,233,0) 100%)'
      },
      'bgImg': {
        'bgColor': '#000000',
        'gradLeft': '',
        'gradRight': '',
        'maxWidth': 'none'
      },
      'product': '',
      'serve_1': true,
      'serve_2': false
    },
    'recipes': {
      1: {
        'image': "./serves/carouselFull__serve--1.png",
        'units': "PLACEHOLDER",
        'copy': {
          'ingredients': {
            1: {
              'measure': "PLACEHOLDER",
              'ingredient': "PLACEHOLDER",
            },
            2: {
              'measure': "PLACEHOLDER",
              'ingredient': "PLACEHOLDER",
            }
          },
          'garnish': {
            1: "PLACEHOLDER",
          },
          'method': [
            "PLACEHOLDER",
            "PLACEHOLDER"
          ],
        }
      },
      2: {
        'image': './serves/carouselFull__serve--1.png',
        'units': 'PLACEHOLDER',
        'copy': {
          'ingredients': {
            1: {
              'measure': 'PLACEHOLDER',
              'ingredient': 'PLACEHOLDER'
            },
            2: {
              'measure': 'PLACEHOLDER',
              'ingredient': 'PLACEHOLDER'
            },
            3: {
              'measure': 'PLACEHOLDER',
              'ingredient': 'PLACEHOLDER'
            },
            4: {
              'measure': 'PLACEHOLDER',
              'ingredient': 'PLACEHOLDER'
            }
          },
          'garnish': {
            1: "PLACEHOLDER"
          },
          'method': [
            'PLACEHOLDER'
          ]
        }
      }

    }
  },

  '6': {
    'apiEndpoint': 'https://api.channelsight.com/api/1.44/feed?key=b0d332b1-2100-40ad-89e1-c696c042a3c4&assetId=2279',
    'prodName': 'Gordon’s White Peach Gin 70cl',
    'prodImg': './widget/product--6.png',
    'navBgColor': '#912b88',
    'navLogoSrc': './navbar/logo--white.svg',
    'retailers': {

    },
    'ui': {
      'primaryColor': '#000000'
    },
    'hero': {
      'video': {
        'active': false,
        'bgColor': '#000000',
        'gradLeft': 'linear-gradient(90deg, rgba(41,217,233,1) 0%, rgba(41,217,233,0) 100%)',
        'gradRight': 'linear-gradient(-90deg, rgba(41,217,233,1) 0%, rgba(41,217,233,0) 100%)'
      },
      'bgImg': {
        'bgColor': '#000000',
        'gradLeft': '',
        'gradRight': '',
        'maxWidth': 'none'
      },
      'product': '',
      'serve_1': true,
      'serve_2': false
    },
    'recipes': {
      1: {
        'image': "./serves/carouselFull__serve--1.png",
        'units': "PLACEHOLDER",
        'copy': {
          'ingredients': {
            1: {
              'measure': "PLACEHOLDER",
              'ingredient': "PLACEHOLDER",
            },
            2: {
              'measure': "PLACEHOLDER",
              'ingredient': "PLACEHOLDER",
            }
          },
          'garnish': {
            1: "PLACEHOLDER",
          },
          'method': [
            "PLACEHOLDER",
            "PLACEHOLDER"
          ],
        }
      },
      2: {
        'image': './serves/carouselFull__serve--1.png',
        'units': 'PLACEHOLDER',
        'copy': {
          'ingredients': {
            1: {
              'measure': 'PLACEHOLDER',
              'ingredient': 'PLACEHOLDER'
            },
            2: {
              'measure': 'PLACEHOLDER',
              'ingredient': 'PLACEHOLDER'
            },
            3: {
              'measure': 'PLACEHOLDER',
              'ingredient': 'PLACEHOLDER'
            },
            4: {
              'measure': 'PLACEHOLDER',
              'ingredient': 'PLACEHOLDER'
            }
          },
          'garnish': {
            1: "PLACEHOLDER"
          },
          'method': [
            'PLACEHOLDER'
          ]
        }
      }

    }
  },
  '7': {
    'apiEndpoint': 'https://api.channelsight.com/api/1.44/feed?key=b0d332b1-2100-40ad-89e1-c696c042a3c4&assetId=2280',
    'prodName': 'Gordon’s Mediterranean Orange Gin 70cl',
    'prodImg': './widget/product--7.png',
    'navBgColor': '#912b88',
    'navLogoSrc': './navbar/logo--white.svg',
    'retailers': {

    },
    'ui': {
      'primaryColor': '#000000'
    },
    'hero': {
      'video': {
        'active': false,
        'bgColor': '#000000',
        'gradLeft': 'linear-gradient(90deg, rgba(41,217,233,1) 0%, rgba(41,217,233,0) 100%)',
        'gradRight': 'linear-gradient(-90deg, rgba(41,217,233,1) 0%, rgba(41,217,233,0) 100%)'
      },
      'bgImg': {
        'bgColor': '#000000',
        'gradLeft': '',
        'gradRight': '',
        'maxWidth': 'none'
      },
      'product': '',
      'serve_1': true,
      'serve_2': false
    },
    'recipes': {
      1: {
        'image': "./serves/carouselFull__serve--1.png",
        'units': "PLACEHOLDER",
        'copy': {
          'ingredients': {
            1: {
              'measure': "PLACEHOLDER",
              'ingredient': "PLACEHOLDER",
            },
            2: {
              'measure': "PLACEHOLDER",
              'ingredient': "PLACEHOLDER",
            }
          },
          'garnish': {
            1: "PLACEHOLDER",
          },
          'method': [
            "PLACEHOLDER",
            "PLACEHOLDER"
          ],
        }
      },
      2: {
        'image': './serves/carouselFull__serve--1.png',
        'units': 'PLACEHOLDER',
        'copy': {
          'ingredients': {
            1: {
              'measure': 'PLACEHOLDER',
              'ingredient': 'PLACEHOLDER'
            },
            2: {
              'measure': 'PLACEHOLDER',
              'ingredient': 'PLACEHOLDER'
            },
            3: {
              'measure': 'PLACEHOLDER',
              'ingredient': 'PLACEHOLDER'
            },
            4: {
              'measure': 'PLACEHOLDER',
              'ingredient': 'PLACEHOLDER'
            }
          },
          'garnish': {
            1: "PLACEHOLDER"
          },
          'method': [
            'PLACEHOLDER'
          ]
        }
      }

    }
  },
  '8': {
    'apiEndpoint': 'https://api.channelsight.com/api/1.44/feed?key=b0d332b1-2100-40ad-89e1-c696c042a3c4&assetId=2281',
    'prodName': 'Gordon’s Sloe Gin 70cl',
    'prodImg': './widget/product--8.png',
    'navBgColor': '#912b88',
    'navLogoSrc': './navbar/logo--white.svg',
    'retailers': {

    },
    'ui': {
      'primaryColor': '#000000'
    },
    'hero': {
      'video': {
        'active': false,
        'bgColor': '#000000',
        'gradLeft': 'linear-gradient(90deg, rgba(41,217,233,1) 0%, rgba(41,217,233,0) 100%)',
        'gradRight': 'linear-gradient(-90deg, rgba(41,217,233,1) 0%, rgba(41,217,233,0) 100%)'
      },
      'bgImg': {
        'bgColor': '#000000',
        'gradLeft': '',
        'gradRight': '',
        'maxWidth': 'none'
      },
      'product': '',
      'serve_1': true,
      'serve_2': false
    },
    'recipes': {
      1: {
        'image': "./serves/carouselFull__serve--1.png",
        'units': "PLACEHOLDER",
        'copy': {
          'ingredients': {
            1: {
              'measure': "PLACEHOLDER",
              'ingredient': "PLACEHOLDER",
            },
            2: {
              'measure': "PLACEHOLDER",
              'ingredient': "PLACEHOLDER",
            }
          },
          'garnish': {
            1: "PLACEHOLDER",
          },
          'method': [
            "PLACEHOLDER",
            "PLACEHOLDER"
          ],
        }
      },
      2: {
        'image': './serves/carouselFull__serve--1.png',
        'units': 'PLACEHOLDER',
        'copy': {
          'ingredients': {
            1: {
              'measure': 'PLACEHOLDER',
              'ingredient': 'PLACEHOLDER'
            },
            2: {
              'measure': 'PLACEHOLDER',
              'ingredient': 'PLACEHOLDER'
            },
            3: {
              'measure': 'PLACEHOLDER',
              'ingredient': 'PLACEHOLDER'
            },
            4: {
              'measure': 'PLACEHOLDER',
              'ingredient': 'PLACEHOLDER'
            }
          },
          'garnish': {
            1: "PLACEHOLDER"
          },
          'method': [
            'PLACEHOLDER'
          ]
        }
      }

    }
  },
  '9': {
    'apiEndpoint': 'https://api.channelsight.com/api/1.46/feed?key=b0d332b1-2100-40ad-89e1-c696c042a3c4&assetId=2408',
    'prodName': 'Gordon\'s Premium Pink 0.0% Alcohol Free Spirit 70cl',
    'prodImg': './widget/product--9.png',
    'navBgColor': '#ffffff',
    'navLogoSrc': './navbar/logo--00-dark.svg',
    'retailers': {
    },
    'carousel': true,
    'carouselFull': false,
    'carouselData': {
      1: {
        9: {
          'title': "Gordon’s Premium Pink 0.0% Alcohol Free Spirit&nbsp;70cl",
          'img': "./products/prod--9.png",
          'url': "",
          'dataAssetId': "2236"
        },
        10: {
          'title': "Gordon’s 0.0% Alcohol Free Spirit&nbsp;70cl",
          'img': "./products/prod--10.png",
          'url': "",
          'dataAssetId': "2236"
        }
      }
    },
    'ui': {
      'primaryColor': '#1c449c'
    },
    'hero': {
      'video': {
        'active': false,
        'bgColor': '#29d9e9',
        'gradLeft': 'linear-gradient(90deg, rgba(41,217,233,1) 0%, rgba(41,217,233,0) 100%)',
        'gradRight': 'linear-gradient(-90deg, rgba(41,217,233,1) 0%, rgba(41,217,233,0) 100%)'
      },
      'bgImg': {
        'bgColor': '#439aaf',
        'gradLeft': '',
        'gradRight': '',
        'maxWidth': 'none'
      },
      'product': '',
      'serve_1': true,
      'serve_2': true
    },
    'recipes': {
      1: {
        'image': "./serves/carouselFull__serve--1.png",
        'units': "1.9 UK Units",
        'copy': {
          'ingredients': {
            1: {
              'measure': "WRONG",
              'ingredient': "WRONG",
            },
            2: {
              'measure': "150-200ml",
              'ingredient': "TONIC",
            }
          },
          'garnish': {
            1: "WEDGE OF PASSION FRUIT",
          },
          'method': [
            "ADD ALL THE INGREDIENTS TO A COPA GLASS",
            "FILL WITH ICE"
          ],
        }
      },
      2: {
        'image': './serves/carouselFull__serve--1.png',
        'units': '1.875 UK Units',
        'copy': {
          'ingredients': {
            1: {
              'measure': '50ML',
              'ingredient': 'GORDON\'s PASSIONFRUIT'
            },
            2: {
              'measure': '100ML',
              'ingredient': 'PINEAPPLE JUICE'
            },
            3: {
              'measure': '12.5ML',
              'ingredient': 'LIME JUICE'
            },
            4: {
              'measure': '12.5ML',
              'ingredient': 'VANILLA SYRUP'
            }
          },
          'garnish': {
            1: "WEDGE OF PASSION FRUIT"
          },
          'method': [
            'ADD ALL THE INGREDIENTS TO A COCKTAIL SHAKER',
            'FILL WITH ICE',
            'SHAKE TO MIX ',
            'FINE-STRAIN INTO A CHILLED',
            'MARTINI GLASS OR COUPE'
          ]
        }
      }

    }
  },
  '10': {
    'apiEndpoint': 'https://api.channelsight.com/api/1.46/feed?key=b0d332b1-2100-40ad-89e1-c696c042a3c4&assetId=2416',
    'prodName': 'Gordon’s 0.0% Alcohol Free Spirit 70cl',
    'prodImg': './widget/product--10.png',
    'retailers': {
    },
    'carousel': true,
    'carouselFull': false,
    'carouselData': {
      1: {
        9: {
          'title': "Gordon\'s Premium Pink 0.0% Alcohol Free Spirit&nbsp;70cl",
          'img': "./products/prod--9.png",
          'url': "",
          'dataAssetId': "2236"
        },
        10: {
          'title': "Gordon\'s 0.0% Alcohol Free Spirit&nbsp;70cl",
          'img': "./products/prod--10.png",
          'url': "",
          'dataAssetId': "2236"
        }
      }
    },
    'ui': {
      'primaryColor': '#1c449c'
    },
    'hero': {
      'video': {
        'active': false,
        'bgColor': '#29d9e9',
        'gradLeft': 'linear-gradient(90deg, rgba(41,217,233,1) 0%, rgba(41,217,233,0) 100%)',
        'gradRight': 'linear-gradient(-90deg, rgba(41,217,233,1) 0%, rgba(41,217,233,0) 100%)'
      },
      'bgImg': {
        'bgColor': '#439aaf',
        'gradLeft': '',
        'gradRight': '',
        'maxWidth': 'none'
      },
      'product': '',
      'serve_1': true,
      'serve_2': true
    },
    'recipes': {
      1: {
        'image': "./serves/carouselFull__serve--1.png",
        'units': "1.9 UK Units",
        'copy': {
          'ingredients': {
            1: {
              'measure': "WRONG",
              'ingredient': "WRONG",
            },
            2: {
              'measure': "150-200ml",
              'ingredient': "TONIC",
            }
          },
          'garnish': {
            1: "WEDGE OF PASSION FRUIT",
          },
          'method': [
            "ADD ALL THE INGREDIENTS TO A COPA GLASS",
            "FILL WITH ICE"
          ],
        }
      },
      2: {
        'image': './serves/carouselFull__serve--1.png',
        'units': '1.875 UK Units',
        'copy': {
          'ingredients': {
            1: {
              'measure': '50ML',
              'ingredient': 'GORDON\'s PASSIONFRUIT'
            },
            2: {
              'measure': '100ML',
              'ingredient': 'PINEAPPLE JUICE'
            },
            3: {
              'measure': '12.5ML',
              'ingredient': 'LIME JUICE'
            },
            4: {
              'measure': '12.5ML',
              'ingredient': 'VANILLA SYRUP'
            }
          },
          'garnish': {
            1: "WEDGE OF PASSION FRUIT"
          },
          'method': [
            'ADD ALL THE INGREDIENTS TO A COCKTAIL SHAKER',
            'FILL WITH ICE',
            'SHAKE TO MIX ',
            'FINE-STRAIN INTO A CHILLED',
            'MARTINI GLASS OR COUPE'
          ]
        }
      }

    }
  }
}


export { dataModel as default };